"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormType = void 0;
/** Standard widget requiring network data */
/** Widgets that do not need network data */
let FormType = exports.FormType = /*#__PURE__*/function (FormType) {
  FormType["TABLE"] = "table";
  FormType["INPUT"] = "input";
  FormType["KANBAN"] = "kanban";
  return FormType;
}({});